import { trackBannerClicked, trackHoverSubTabClicked } from "@/tracking";
import { getStaticImgUrl } from "@/utils/imageUtil";
import { SetStateAction } from "react";
import { useNavigate } from "react-router-dom";

const HeaderSubTab = ({
  tabs,
  setIsOpenSubTab,
}: {
  tabs: any;
  setIsOpenSubTab: React.Dispatch<SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();

  const linkToSubTab = (subTab: any) => {
    subTab.cate_cd ? navigate(`/post?cate=${subTab.cate_cd}`) : navigate(subTab.url);
    setIsOpenSubTab(false);
  };

  return (
    <nav
      className="header-sub-tab-container bg-white shadow-header pt-4 pb-5 animated-header lg:block hidden"
      onMouseEnter={() => setIsOpenSubTab(true)}
      onMouseLeave={() => setIsOpenSubTab(false)}
    >
      <div className="w-full z-[100]">
        <div className="custom-scrollbar min-h-[40vh] max-h-[40vh] overflow-y-auto overflow-x-hidden w-[calc(100%-8px)]">
          <div className="max-w-[1200px] w-full mx-auto px-4 xl:px-0 relative">
            <div className="flex justify-around text-sm">
              {tabs.map(
                (tab: {
                  label: string;
                  value: string;
                  width: number;
                  subTabs: {
                    cate_name: string;
                    value: string;
                    url: string;
                  }[];
                }) => {
                  return (
                    <div
                      key={tab.value}
                      style={{ width: tab.width }}
                      onClick={() => trackHoverSubTabClicked({ type: tab.value })}
                      className="relative"
                    >
                      <div className="flex flex-col space-y-3 text-gray-600">
                        {tab.subTabs.map((subTab, subIdx) => {
                          return (
                            <div
                              onClick={() => linkToSubTab(subTab)}
                              className="whitespace-nowrap text-secondary-900 font-normal text-sm leading-5 cursor-pointer hover:text-primary"
                              key={`${tab.value}-${subIdx}`}
                            >
                              {subTab.cate_name}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                },
              )}
            </div>
            {/* Promotional Banner */}
            <div
              className="absolute top-[82px] left-[140px] cursor-pointer z-10"
              onClick={() => {
                trackBannerClicked({ origin: "hover-menu" });
                window.location.href = import.meta.env.VITE_APP_HOME_SUB_TAB_URL;
              }}
            >
              <img
                src={getStaticImgUrl("hover-menu-banner.png")}
                className="rounded-xl xl:w-[320px] w-[260px]"
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderSubTab;
